/**
 * AllAttendanceRequests — unified "All attendance requests" admin view
 * (2026-06-15). A single pane of glass over all 6 worker-submitted attendance
 * request types (leave / overtime / missed-punch / business-trip / off-site /
 * shift-change), the admin counterpart to the mobile worker's unified
 * Attendance requests surface.
 *
 * Thin wrapper around <ApprovalList allTypes>: that mode fetches every worker
 * type (face-review approvals excluded), shows a Type column + a type filter,
 * and renders a generic per-type Details summary. The 6 per-type pages remain
 * for type-specific column richness + on-behalf creation; this page is the
 * cross-type triage queue (filter by type/status/department, bulk approve/
 * reject, single approve/reject).
 */
import React from 'react';
import ApprovalList from './ApprovalList';
import { useTranslation } from 'react-i18next';

const AllAttendanceRequests: React.FC = () => {
  const { t } = useTranslation();
  return (
    <ApprovalList
      allTypes
      title={t('attendance:approvals.all.title')}
      description={t('attendance:approvals.all.description')}
      recordTitle={t('attendance:approvals.all.title')}
      emptyHint={t('attendance:approvals.all.empty')}
      filterLabel={t('attendance:approvals.filterLabel')}
    />
  );
};

export default AllAttendanceRequests;
